// @flow

import React, { Component } from 'react';
import { get } from 'lodash';
import { Query } from 'react-apollo';
import { withRouter, Redirect } from 'react-router-dom';
import type { Location } from 'react-router-dom';
import { parse } from 'qs';
import { connect } from 'react-redux';
import { components } from '@peachjar/components';

import schoolOrDistrictRegistrationQuery from '../utils/schoolOrDistrictRegistration.query';
import VerifyEmailContainer from './VerifyEmailContainer';
import UserRegistrationContainer from './UserRegistrationContainer';

const { Spinner } = components.LoadingIndicators;

const pages = [UserRegistrationContainer, VerifyEmailContainer];

type Props = {|
  +id: string,
|};

type State = {|
  page: number,
|};

class UserRegistrationStateMachine extends Component<Props, State> {
  state = {
    page: 0,
    hasPaidAndSigned: false,
  };

  componentDidMount() {
    if (get(this.props.data, 'schoolOrDistrictRegistration.registrant.email')) {
      this.setState({
        page: 1,
      });
    }

    if (
      get(this.props.data, 'schoolOrDistrictRegistration.paymentStatus') === 'paid' &&
      get(this.props.data, 'schoolOrDistrictRegistration.agreementStatus') === 'signed'
    ) {
      this.setState({
        hasPaidAndSigned: true,
      });
    }
  }

  nextPage = () => {
    const { page } = this.state;
    this.setState({ page: page + 1 });
  };

  previousPage = () => {
    const { page } = this.state;
    this.setState({ page: page - 1 });
  };

  render() {
    const { page, hasPaidAndSigned } = this.state;
    const { data, id, loading, error } = this.props;
    const CurrentPage = pages[page];

    if (loading) {
      return <Spinner />;
    }

    return (
      <CurrentPage
        id={id}
        data={data}
        hasPaidAndSigned={hasPaidAndSigned}
        nextPage={this.nextPage}
        previousPage={this.previousPage}
      />
    );
  }
}

const mapStateToProps = state => ({
  registrationId: state.onboarding.registrationId,
});

export default withRouter(
  connect(mapStateToProps)(UserRegistrationStateMachine)
);



// WEBPACK FOOTER //
// ./src/Onboarding/Registration/onboarding/containers/UserRegistration/containers/UserRegistrationStateMachine.jsx